// Institute of Design and Innovation (email idi@unm.edu). //

import { Sponsor, SponsorDetail } from '@/models/sponsor'
import { AxiosResponse } from 'axios'
import httpClient from './httpClient'

/**
 *  Class contain routes for the SponsorService API
 */
export default class SponsorService {
  /**
   * Get all sponsors
   */
  public static getAll (): Promise<AxiosResponse<Array<Sponsor>>> {
    return httpClient.get('sponsor')
  }

  /**
   * Get all sponsors with details included
   */
  public static getAllDetailed (): Promise<AxiosResponse<Array<SponsorDetail>>> {
    return httpClient.get('sponsor', { params: { includeAppointmentType: 'true' } })
  }

  /**
   * Create sponsor
   * @param sponsor the sponsor data to create
   */
  public static create (sponsor: Sponsor): Promise<AxiosResponse<SponsorDetail>> {
    return httpClient.post('sponsor', sponsor)
  }

  /**
   * Update sponsor
   * @param id the Id of the sponsor
   * @param sponsor the sponsor data to update
   */
  public static update (id: number, sponsor: Sponsor): Promise<AxiosResponse<SponsorDetail>> {
    return httpClient.put(`sponsor/${id}`, sponsor)
  }

  /**
   * Remove sponsor
   * @param id the Id of the sponsor
   */
  public static remove (id: number): Promise<AxiosResponse<SponsorDetail>> {
    return httpClient.put(`sponsor/remove/${id}`)
  }
}
